import React from "react";
import * as Cesium from 'cesium';
import AnnotationName from "../AnnotationName";
import ProjectDescription from "../ProjectDescription";
import MarkerPicker from "components/common/MarkerPicker";
import { GetSVGContent } from "../../../../MapView/MapUtils";
import useProjectStore from "../../../../../store-zustand/project"

const MarkerSettings = ({ annotation }) => {
  const { setcurrentAnnotationIcon, setcurrentAnnotationColor, setcurrentPinSize } = useProjectStore();
  
  const setPickedPin = (materialItem) => {
    setcurrentAnnotationIcon(`${materialItem}.svg`);
    if (window['CurrentPinMarker']) {
      if (!window['CurrentPinMarker'].PinColor) {
        window['CurrentPinMarker'].PinColor = Cesium.Color.fromCssColorString("#487BF2");
      }

      window['CurrentPinMarker'].PinName = `${materialItem}.svg`;
      let color = window['CurrentPinMarker'].PinColor.toCssHexString().toUpperCase();
      GetSVGContent(color, window['CurrentPinMarker'], function (result) {
        window['CurrentPinMarker'].PinMarker = result.src;
        window['CurrentPinMarker']._billboards[0].image = result.src;
      });

    } else if (window.annotationObj[`${window.actualAnnotationId}`]) {
      if (!window.annotationObj[`${window.actualAnnotationId}`]) return
      window.annotationObj[`${window.actualAnnotationId}`].PinName = `${materialItem}.svg`;

      let color = window.annotationObj[`${window.actualAnnotationId}`].PinColor.toCssColorString();
      GetSVGContent(color, window.annotationObj[`${window.actualAnnotationId}`], function (result) {
        window.annotationObj[`${window.actualAnnotationId}`].PinMarker = result.src;
      });
    }
  }

  const setPickedPinsize = (size) => {
    setcurrentPinSize(size == 1 ? 50 : size == 2 ? 60 : 40);
    if (window['CurrentPinMarker']) {
      if (size == 1) {
        window['CurrentPinMarker']._billboards[0].width = 50;
        window['CurrentPinMarker']._billboards[0].height = 50;
        window['CurrentPinMarker']._billboards[0].pinwidth = 50;
        window['CurrentPinMarker']._billboards[0].pinheight = 50;
      } else if (size == 2) {
        window['CurrentPinMarker']._billboards[0].width = 60;
        window['CurrentPinMarker']._billboards[0].height = 60;
        window['CurrentPinMarker']._billboards[0].pinwidth = 60;
        window['CurrentPinMarker']._billboards[0].pinheight = 60;
      } else {
        window['CurrentPinMarker']._billboards[0].width = 40;
        window['CurrentPinMarker']._billboards[0].height = 40;
        window['CurrentPinMarker']._billboards[0].pinwidth = 40;
        window['CurrentPinMarker']._billboards[0].pinheight = 40;
      }
    } else if (window.annotationObj[`${window.actualAnnotationId}`]) {
      if (size == 1) {
        window.annotationObj[`${window.actualAnnotationId}`].pinwidth = 50;
        window.annotationObj[`${window.actualAnnotationId}`].pinheight = 50;
      } else if (size == 2) {
        window.annotationObj[`${window.actualAnnotationId}`].pinwidth = 60;
        window.annotationObj[`${window.actualAnnotationId}`].pinheight = 60;
      } else {
        window.annotationObj[`${window.actualAnnotationId}`].pinwidth = 40;
        window.annotationObj[`${window.actualAnnotationId}`].pinheight = 40;
      }
    }
  }

  const setpincolor = (color) => {
    setcurrentAnnotationColor(color);
    if (window['CurrentPinMarker']) {
      window['CurrentPinMarker'].PinColor = Cesium.Color.fromCssColorString(color);
      GetSVGContent(window['CurrentPinMarker'].PinColor.toCssHexString().toUpperCase(), window['CurrentPinMarker'], function (result) {
        window['CurrentPinMarker'].PinMarker = result.src;
        window['CurrentPinMarker']._billboards[0].image = result.src;
      });
    } else if (window.annotationObj[`${window.actualAnnotationId}`]) {
      window.annotationObj[`${window.actualAnnotationId}`].PinColor = Cesium.Color.fromCssColorString(color);
      GetSVGContent(color, window.annotationObj[`${window.actualAnnotationId}`], function (result) {
        window.annotationObj[`${window.actualAnnotationId}`].PinMarker = result.src;
      });
    }
  }

  const LabelColorvalue = (color) => {
    if (!window.annotationObj[`${window.actualAnnotationId}`]) return

    window.annotationObj[`${window.actualAnnotationId}`].LabelfillColor = Cesium.Color.fromCssColorString(color);
  }

  const Labelsizevalue = (size) => {
    if (!window.annotationObj[`${window.actualAnnotationId}`]) return

    if (size == 1) {
      window.annotationObj[`${window.actualAnnotationId}`].Labelfontsize = '11px';
    } else if (size == 2) {
      window.annotationObj[`${window.actualAnnotationId}`].Labelfontsize = '14px';
    } else {
      window.annotationObj[`${window.actualAnnotationId}`].Labelfontsize = '8px';
    }
  }

  return (
    <div>
      <AnnotationName name={annotation.name} type={annotation.type} />
      <ProjectDescription description={annotation.description} />
      <MarkerPicker label="Styling" setPickedPin={setPickedPin} setPickedPinsize={setPickedPinsize} setpincolor={setpincolor} Labelsizevalue={Labelsizevalue} LabelColorvalue={LabelColorvalue} />
    </div>
  );
};

export default MarkerSettings;